import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerObject } from 'src/app/_interfaces/cinema/CustomerObject';
import { environment } from 'src/environments/environment';

const API_URL = environment.prismaApiUrl +'/api/dispo/employees';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  currentObject: any;
  isNew: Boolean = false;
  cid: any;

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(API_URL);
  }

  getAllById(id: any): Observable<any> {
    this.cid = id;
    return this.http.get(API_URL + '/get-all-by-id/' + id);
  }

  storeLocations(id:any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-locations/' + id, {data: object});
  }

  store(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL, {data: object});
  }

  storeClassParams(id:any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-class-params/' + id, {data: object});
  }

  storeIndex(id:any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-index/' + id, {data: object});
  }

  delete(object: any): Observable<any> {
    return this.http.delete(API_URL + '/' + object.id);
  }

  show(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/' + id);
    return this.currentObject;
  }

  update(object: any): Observable<any> {
    return this.http.put<CustomerObject>(API_URL + '/' + object.id, {data: object});
  }

  genPDF(): Observable<any> {
    return this.http.get(API_URL + '/gen-pdf', {responseType: 'arraybuffer'});
  }

  getCurrentObject() {
    return this.currentObject;
  }

  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }

  setCId(value: any) {
    this.cid = value;
  }

  getCId() {
    return this.cid;
  }
}
